import { render, staticRenderFns } from "./DashboardDefinition.vue?vue&type=template&id=56bd57b6"
import script from "./DashboardDefinition.vue?vue&type=script&lang=js"
export * from "./DashboardDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports